import { render, staticRenderFns } from "./RadioVirtualAccountOpen.vue?vue&type=template&id=309cdadc&lang=pug"
import script from "./RadioVirtualAccountOpen.vue?vue&type=script&lang=js"
export * from "./RadioVirtualAccountOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports